'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AsyncPropTypeBanner = function (_React$Component) {
  _inherits(AsyncPropTypeBanner, _React$Component);

  function AsyncPropTypeBanner(props) {
    _classCallCheck(this, AsyncPropTypeBanner);

    var _this = _possibleConstructorReturn(this, (AsyncPropTypeBanner.__proto__ || Object.getPrototypeOf(AsyncPropTypeBanner)).call(this, props));

    _this.state = {
      AsyncComponent: null
    };
    return _this;
  }

  _createClass(AsyncPropTypeBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!_enviro2.default.deployed()) {
        import( /* webpackChunkName: "proptype-banner" */'conversations-internal-components/proptype-banner/components/PropTypeBanner').then(function (AsyncComponent) {
          _this2.setState({
            AsyncComponent: AsyncComponent
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Component = this.state.AsyncComponent;

      if (!Component) {
        return null;
      }

      return _react2.default.createElement(Component, null);
    }
  }]);

  return AsyncPropTypeBanner;
}(_react2.default.Component);

exports.default = AsyncPropTypeBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/code-splitting/components/AsyncPropTypeBanner.js
// module id = 935
// module chunks = 2 3